import React, { useEffect, useState } from 'react';
import { Table, InputNumber, message, Select, Button, Row, Col } from 'antd';
import planesAccionService from '../../../services/informacion_genero/planes_accion/planes_accionService';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../store/auth/selectors';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const { Option } = Select;

const PlanAccion = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tipo = params.get('tipo');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedProyecto, setSelectedProyecto] = useState(null);
    const [selectedOrganizacion, setSelectedOrganizacion] = useState(null);
    const appName = 'planes-accion-fao';
    const permissions = useSelector((state) => selectAppPermissions(state, appName));
    const permissionUpdate = permissions.priv_update === 'Y';

    const fetchPlanes = async () => {
        setLoading(true);
        try {
            const result = await planesAccionService.getPlanesAccion();
            const planes = result[tipo];
            setData(planes);
            setFilteredData(planes);
        } catch (err) {
            message.error("Error al cargar los datos");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlanes();
    }, [tipo]);

    const handleChange = async (oid, field, value) => {
        const updated = data.map((item) =>
            item.oid === oid ? { ...item, [field]: value } : item
        );
        setData(updated);
        applyFilters(selectedProyecto, selectedOrganizacion, updated);
        try {
            const current = updated.find((item) => item.oid === oid);

            await planesAccionService.updatePlanesAccion(
                current.oid,
                current.propuesto,
                current.ejecucion
            );
            message.success('Actualizado correctamente');
        } catch (error) {
            message.error('Error al actualizar');
        }
    };

    const applyFilters = (proyecto, organizacion, dataset = data) => {
        let filtered = dataset;

        if (proyecto) {
            filtered = filtered.filter(item => item.proyecto === proyecto);
        }
        if (organizacion) {
            filtered = filtered.filter(item => item.organizacion === organizacion);
        }

        setFilteredData(filtered);
    };

    const clearFilters = () => {
        setSelectedProyecto(null);
        setSelectedOrganizacion(null);
        setFilteredData(data);
    };

    const proyectosUnicos = [...new Set(data.map(item => item.proyecto))];
    const organizacionesUnicas = [...new Set(data.map(item => item.organizacion))];

    const columns = [
        {
            title: 'Proyecto',
            dataIndex: 'proyecto',
            key: 'proyecto',
        },
        {
            title: 'Organización',
            dataIndex: 'organizacion',
            key: 'organizacion',
        },
        {
            title: 'Propuesto',
            dataIndex: 'propuesto',
            key: 'propuesto',
            align: 'center',
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    disabled={!permissionUpdate} // <- aquí controlas si se puede editar
                    onChange={(val) => handleChange(record.oid, 'propuesto', val)}
                />
            ),
        },
        {
            title: 'Ejecución',
            dataIndex: 'ejecucion',
            key: 'ejecucion',
            align: 'center',
            render: (value, record) => (
                <InputNumber
                    min={0}
                    value={value}
                    disabled={!permissionUpdate} // <- misma lógica aquí
                    onChange={(val) => handleChange(record.oid, 'ejecucion', val)}
                />
            ),
        },

        {
            title: 'Avance (%)',
            key: 'avance',
            align: 'center',
            render: (_, record) => {
                const { propuesto, ejecucion } = record;
                const avance = propuesto > 0 ? ((ejecucion || 0) * 100) / propuesto : 0;
                return `${Math.round(avance)}%`;
            },

        },
    ];

    const exportToExcel = () => {
        // Mapear los datos para el excel
        const exportData = filteredData.map(({ proyecto, organizacion, propuesto, ejecucion }) => ({
            Proyecto: proyecto,
            Organización: organizacion,
            Propuesto: propuesto,
            Ejecución: ejecucion,
            'Avance (%)': propuesto > 0 ? Math.round(((ejecucion || 0) * 100) / propuesto) : 0,
        }));

        // Crear hoja
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Calcular ancho de columnas
        const objectMaxLength = (arr, key) => {
            return Math.max(
                key.length, // el título de la columna
                ...arr.map(item => (item[key] ? item[key].toString().length : 0))
            );
        };

        worksheet['!cols'] = [
            { wch: objectMaxLength(exportData, 'Proyecto') + 2 },      // +2 para un poco de margen
            { wch: objectMaxLength(exportData, 'Organización') + 2 },
            { wch: objectMaxLength(exportData, 'Propuesto') + 2 },
            { wch: objectMaxLength(exportData, 'Ejecución') + 2 },
            { wch: objectMaxLength(exportData, 'Avance (%)') + 2 },
        ];

        // Crear libro y añadir hoja
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Planes de Acción");

        // Generar buffer y descargar archivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'planes_accion.xlsx');
    };


    return (
        <div className="container">
            <div className="row mb-2 d-flex align-items-center">
                <div className="col-md-8 linea_separador mb-2 d-flex align-items-center">
                    <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
                        <p>PROYECTO UTF <br /> COL 160 COL</p>
                    </div>
                    <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
                        <p>
                            Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
                        </p>
                    </div>
                </div>
                <div className="col-md-4 d-flex justify-content-center align-items-center flex-column">
                    <h2 className="text-center mb-2">
                        {tipo === '1'
                            ? 'Plan de acción ejecutado por FAO'
                            : 'Plan de acción ejecutado por Organizaciones'}
                    </h2>
                </div>
            </div>

            {/* Filtros */}
            <Row gutter={16} className="mb-3">
                <Col span={6}>
                    <Select
                        allowClear
                        value={selectedProyecto}
                        placeholder="Filtrar por Proyecto"
                        onChange={(value) => {
                            setSelectedProyecto(value);
                            applyFilters(value, selectedOrganizacion);
                        }}
                        style={{ width: '100%' }}
                    >
                        {proyectosUnicos.map((proyecto) => (
                            <Option key={proyecto} value={proyecto}>
                                {proyecto}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col span={6}>
                    <Select
                        allowClear
                        value={selectedOrganizacion}
                        placeholder="Filtrar por Organización"
                        onChange={(value) => {
                            setSelectedOrganizacion(value);
                            applyFilters(selectedProyecto, value);
                        }}
                        style={{ width: '100%' }}
                    >
                        {organizacionesUnicas.map((org) => (
                            <Option key={org} value={org}>
                                {org}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Button onClick={clearFilters}>Limpiar filtros</Button>
                </Col>
                <Col>
                    <Button type="primary" onClick={exportToExcel}>
                        Exportar a Excel
                    </Button>
                </Col>
            </Row>
            <Row gutter={16} className="mb-3">

            </Row>
            <div className="participant-count-container">
                <h1 className="participant-count-title">
                    Total registros: <span className="participant-count-number">{filteredData.length}</span>
                </h1>
            </div>
            <Table
                dataSource={filteredData}
                columns={columns}
                loading={loading}
                pagination={{ pageSize: 10 }}
                rowKey="oid"
            />
        </div>
    );
};

export default PlanAccion;
